// config.js
export const API_KEY = process.env.REACT_APP_API_KEY;
